/**
 * Shared Mantine `styles` prop overrides used by Flora-agent inputs (TextInput,
 * Textarea, Select, NumberInput, etc.) so every panel keeps the same border,
 * background, and typography treatment without each call site re-declaring it.
 */
const inputStyles = {
  input: {
    borderRadius: 8,
    border: '1px solid var(--sky-light)',
    background: 'var(--base-white)',
    color: 'var(--ink-darkest)',
    fontSize: 14,
  },
};

export { inputStyles };
